import { CanadianWorkersCompensationType } from 'src/app/interfaces/canadian-workers-compensation-type';
import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { CompanyVendor } from './company-vendor';

export class CanadianWorkersCompensation extends BaseModel {
  static CanadianWorkersCompensationProperties: (
    | {
        property: keyof CanadianWorkersCompensation;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof CanadianWorkersCompensation;
        type: 'alias';
      }
    | {
        property: keyof CanadianWorkersCompensation;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyVendorId', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'type', type: 'column', dataType: 'string' },
    { property: 'CAWCNumber', type: 'column', dataType: 'string' },
    { property: 'CAWCcertNumber', type: 'column', dataType: 'string' },
    { property: 'CAWCStatus', type: 'column', dataType: 'string' },
    { property: 'CAWCDate', type: 'column', dataType: 'date' },
    { property: 'CAWCExempt', type: 'column', dataType: 'boolean' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'CompanyVendor', model: 'CompanyVendor', type: 'association' }
  ];

  static {
    CanadianWorkersCompensation.CanadianWorkersCompensationProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          CanadianWorkersCompensation.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          CanadianWorkersCompensation.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          CanadianWorkersCompensation.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(
    CanadianWorkersCompensationObject: Partial<CanadianWorkersCompensation>
  ) {
    super();

    CanadianWorkersCompensation.CanadianWorkersCompensationProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = CanadianWorkersCompensationObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  CompanyVendorId?: number;
  CompanyId?: number;
  VendorId?: number;
  type?: CanadianWorkersCompensationType;
  CAWCNumber?: string | null;
  CAWCcertNumber?: string | null;
  CAWCStatus?: ('Eligible' | 'Ineligible' | 'Preliminary') | null;
  CAWCDate?: Date | null;
  CAWCExempt?: boolean;
  createdAt?: Date;
  updatedAt?: Date;

  CompanyVendor?: CompanyVendor;
}
